import React from "react";

export default function FormattedDate(props){

   let hours = props.date.getHours();
    if (hours <10){
        hours = `0${hours}`;
    }
    let minutes = props.date.getMinutes();
    if (minutes <10) {
        minutes = `0${minutes}`;
    }
    let weekdays=["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
     let day = weekdays[props.date.getDay()];

   return <div>
     Local time: {day} - {hours}:{minutes}
        </div>
 

}